"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Locale = _interopRequireDefault(require("@active/react-utils/i18n/Locale"));
var _compose = _interopRequireDefault(require("lodash/fp/compose"));
var _curryRight = _interopRequireDefault(require("lodash/fp/curryRight"));
var _some = _interopRequireDefault(require("lodash/fp/some"));
var _prop = _interopRequireDefault(require("lodash/fp/prop"));
var _flow = _interopRequireDefault(require("lodash/fp/flow"));
var _keys = _interopRequireDefault(require("lodash/fp/keys"));
var _map = _interopRequireDefault(require("lodash/fp/map"));
var _isObject = _interopRequireDefault(require("lodash/fp/isObject"));
var _isInteger = _interopRequireDefault(require("lodash/fp/isInteger"));
var _flatten = _interopRequireDefault(require("lodash/fp/flatten"));
var _forEach = _interopRequireDefault(require("lodash/fp/forEach"));
var _isArray = _interopRequireDefault(require("lodash/fp/isArray"));
var _isString = _interopRequireDefault(require("lodash/fp/isString"));
var _filter = _interopRequireDefault(require("lodash/fp/filter"));
var _concat = _interopRequireDefault(require("lodash/fp/concat"));
var _Alert = _interopRequireDefault(require("../Alert"));
var _Form = require("../Form");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var _toPaths = function toPaths(object) {
  return (0, _flow["default"])(_keys["default"], (0, _map["default"])(function (key) {
    var symbol = (0, _isInteger["default"])(Number(key)) ? "[".concat(key, "]") : key;
    var value = (0, _prop["default"])(key)(object);
    if ((0, _isObject["default"])(value)) {
      return (0, _map["default"])(function (fieldValue) {
        return "".concat(symbol, ".").concat(fieldValue);
      })(_toPaths(value));
    }
    return value ? symbol : '';
  }), _flatten["default"])(object);
};
var getFieldTouchedChildSize = function getFieldTouchedChildSize(fieldKey) {
  return function (paths) {
    return (0, _filter["default"])(function (path) {
      return path.indexOf(fieldKey) === 0;
    })(paths);
  };
};
var injectNestedFieldsParentKey = function injectNestedFieldsParentKey(values) {
  return function (paths) {
    var parentKeys = [];
    (0, _flow["default"])(_keys["default"], (0, _forEach["default"])(function (key) {
      if ((0, _isArray["default"])(values[key]) && getFieldTouchedChildSize(key)(paths).length === values[key].length) {
        parentKeys.push(key);
      } else if ((0, _isObject["default"])(values[key]) && getFieldTouchedChildSize(key)(paths).length === (0, _keys["default"])(values[key]).length) {
        parentKeys.push(key);
      }
    }))(values);
    return (0, _concat["default"])(parentKeys)(paths);
  };
};
var hasError = function hasError(_ref) {
  var errors = _ref.errors,
    touched = _ref.touched,
    values = _ref.values;
  return (0, _flow["default"])(_toPaths, injectNestedFieldsParentKey(values), (0, _some["default"])(function (value) {
    return (0, _isString["default"])((0, _prop["default"])(value)(errors)) && (0, _prop["default"])(value)(errors);
  }))(touched);
};
var FormError = function FormError(_ref2) {
  var errorMessage = _ref2.errorMessage,
    showError = _ref2.showError,
    _ref2$theme = _ref2.theme,
    theme = _ref2$theme === void 0 ? 'inline' : _ref2$theme;
  return showError ? /*#__PURE__*/_react["default"].createElement("div", {
    className: "flex justify-content-center mg-b-7"
  }, /*#__PURE__*/_react["default"].createElement(_Alert["default"], {
    type: "danger",
    theme: theme === 'regular' ? undefined : theme
  }, errorMessage || /*#__PURE__*/_react["default"].createElement(_Locale["default"], {
    id: "react-ui.form.global.error.message"
  }))) : null;
};
var FormErrorContainer = (0, _compose["default"])((0, _curryRight["default"])(_Form.connectForm)(function (_ref3) {
  var _ref3$form = _ref3.form,
    errors = _ref3$form.errors,
    touched = _ref3$form.touched,
    values = _ref3$form.values;
  return {
    showError: hasError({
      errors: errors,
      touched: touched,
      values: values
    })
  };
}), _react.memo)(FormError);
var _default = exports["default"] = /*#__PURE__*/(0, _react.memo)(FormErrorContainer);